import React, { PureComponent } from "react";
import startCase from "lodash/fp/startCase";
import { BarChart, Bar, ResponsiveContainer, YAxis, XAxis } from "recharts";

import {
  Metric,
  FUNNEL_GRADIENTS,
  selectFormat,
  Error,
} from "components/Utils/Utils.js";
import Heading from "../Elements/Heading.js";

class AdsFunnelByNetwork extends PureComponent {
  renderFunnels = (item, index, funnels) => {
    let COLORS =
      FUNNEL_GRADIENTS[index] ||
      FUNNEL_GRADIENTS[index % FUNNEL_GRADIENTS.length];

    const funnels_selected_data = [];

    funnels.map((funnel, i) => {
      let type = "";
      let value = null;

      type = startCase(funnel);

      if (item && item.data && item.data.length > 0) {
        value = item.data.filter((f) => f.type === funnel)[0].value;
      } else {
        value = item[funnel.toLowerCase()].value;
      }

      return funnels_selected_data.push({
        value: value === 0 ? null : value,
        type: type,
      });
    });

    const chart_height = funnels_selected_data.length * 60;

    return (
      <ResponsiveContainer height={chart_height}>
        <BarChart
          data={funnels_selected_data}
          barCategoryGap={1}
          layout="vertical"
          margin={{ top: 10, right: 0, left: 0, bottom: 0 }}
        >
          <defs>
            <linearGradient id={`gradient${index}`} x1="1" y1="0" x2="0" y2="0">
              <stop offset="5%" stopColor={COLORS[0]} stopOpacity={1} />
              <stop offset="95%" stopColor={COLORS[1]} stopOpacity={1} />
            </linearGradient>
          </defs>

          <XAxis
            type="number"
            dataKey="value"
            hide={true}
            scale="log"
            domain={[0.01, "auto"]}
            allowDataOverflow
          />

          <YAxis
            type="category"
            dataKey="type"
            axisLine={false}
            tickLine={false}
            interval={0}
            fontSize={12}
            fontWeight={700}
            fontFamily={"Museo Slab W01"}
            width={125}
          />
          <Bar
            key={index}
            dataKey="value"
            fill={`url(#gradient${index})`}
            // label={customizedLabel}
            label={{
              position: "insideLeft",
              formatter: (value) => selectFormat("numeric", value),
              fontSize: 13,
              fontWeight: 700,
              fontFamily: "Museo Slab W01",
              offset: 10,
            }}
          />
        </BarChart>
      </ResponsiveContainer>
    );
  };

  renderMetrics = (item, metrics) => {
    const metrics_data = item;
    const metrics_selected_data = [];

    metrics.forEach((metric, i) => {
      metrics_selected_data.push({
        label: metric.label,
        value:
          (metrics_data[metric.name] && metrics_data[metric.name].value) || 0,
        type: metric.type ? metric.type : "number",
      });
    });

    const style = {
      marginLeft: 120,
      borderLeft: `1px dashed #ccc`,
    };

    return (
      <div className="mt-1 mb-4 mr-auto pt-4" style={style}>
        {metrics_selected_data.map((metric, key) => (
          <div
            className="col-6 d-flex flex-column align-items-left mb-3 pl-3 pr-3"
            key={key}
          >
            <Heading size={5} className={"mb-2"}>
              {metric.label}
            </Heading>
            <Metric
              type={metric.type}
              value={metric.value}
              format={metric.format}
              size={"sm"}
            />
          </div>
        ))}
      </div>
    );
  };

  render() {
    const { data, funnels, metrics } = this.props;

    if (data.hasData === false) {
      return <Error minHeight={360} />;
    }
    return (
      <div className="row">
        {data.data
          .filter((s) => s.source !== "Total")
          .map((item, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <div className="text-center">
                <Heading size={6} className={"mb-0 text-gray"}>
                  {item.source || item.name}
                </Heading>
              </div>
              {this.renderFunnels(item, index, funnels)}

              {this.renderMetrics(item, metrics)}
            </div>
          ))}
      </div>
    );
  }
}

export default AdsFunnelByNetwork;
